export enum UserRole {
  USER = 'USER',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER_ADMIN',
  SUPERVISOR = 'SUPERVISOR',
  SECRETARIA = 'SECRETARIA',
  VENDEDOR = 'VENDEDOR',
  RELACIONADOR = 'RELACIONADOR',
  LIDER_VENDAS = 'LIDER_VENDAS',
  ASSOCIADO = 'ASSOCIADO',
  REPRESENTANTE = 'REPRESENTANTE',
  POS_VENDA = 'POS_VENDA'
}

export enum UserStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  PENDING = 'PENDING',
  REJECTED = 'REJECTED'
}

export enum Status {
  ATIVO = 'ATIVO',
  INATIVO = 'INATIVO',
  PENDENTE = 'PENDENTE'
}

export enum ContratoStatus {
  PENDENTE = 'pendente',
  EM_ANDAMENTO = 'em_andamento',
  ATIVO = 'ativo',
  ASSINADO = 'assinado',
  CANCELADO = 'cancelado',
  CONTEMPLADO = 'contemplado'
} 